import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@ts-digital/vrc";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import landingBckImage from "../../../assets/img/tspay_banner_landing-omino.svg";
import { useDispatch, useSelector } from "react-redux";
import { startTsPayOnboardingSession } from "../../../store/actions/tspay/onboarding";
import SimpleLoader from "../../general/loader/index";

const TsPayOnboardingBanner = ({ isLanding}) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoadingOnboardingSession = useSelector(state => state.tspay.isLoadingOnboardingSession.isLoading);

  const manageStartSessionUrl = res => {
    window.open(res.data.sessionUrl, "_blank").focus();
  };

  const startOnboardingSession = () => {
    dispatch(startTsPayOnboardingSession()).then(res => manageStartSessionUrl(res))
		 .then(res => navigate("/"));
  };

  const goToTsPayLanding = () => {
    navigate("/tspay-onboarding");
  };

  const goToHomePage = () => {
    navigate("/");
  };

  const landingBannerContainerStyles = {
    width: "100%",
    margin: 0,
    height: 422,
    backgroundImage: `url(${landingBckImage})`
  };

  const landingTextContainerStyles = {
    height: "59%",
    padding: "18px 0 0 590px"
  };

  const landingTextStyles = {
    maxWidth: 588,
    fontWeight: "bold",
    marginBottom: 20
  };

  return (
    <div className="dbx-tspay-onboarding-banner-container" style={isLanding ? landingBannerContainerStyles : null}>
      {isLanding &&
				<div className="dbx-tspay-onboarding-back-button-container" onClick={() => goToHomePage()}>
				  <FontAwesomeIcon
				    style={{ margin: "0 10px 0 20px", fontWeight: "bold", fontSize: 16}}
				    icon={["fal", "arrow-left"]}
        			/>
				  <p className="dbx-tspay-onboarding-back-button-text"> Torna alla home</p>
				</div>
      }
      <div className="dbx-tspay-onboarding-banner-text-container" style={isLanding ? landingTextContainerStyles : null}>
        <p className="dbx-tspay-onboarding-banner-upper-text"
          style={isLanding ? landingTextStyles : null}
        >
          {!isLanding && <b><FormattedMessage id="dashboard.tsPayText"/></b>}
          <FormattedMessage
            id={isLanding ? "dashboard.tsPayTsPayOnboardingBannerLandingUpperText" : "dashboard.tsPayTsPayOnboardingBannerUpperText"}
          />
        </p>
        <p className="dbx-tspay-onboarding-banner-bottom-text"
				   style={{maxWidth: isLanding && 673}}
        >
          <FormattedMessage
            id={isLanding ? "dashboard.tsPayTsPayOnboardingBannerLandingBottomText" : "dashboard.tsPayTsPayOnboardingBannerBottomText"}
          />
          {isLanding &&
						<>
						  <br></br>
						  <FormattedMessage id="dashboard.tsPayOnboardingBannerLandingBottomText2" />
						</>
          }
        </p>
      </div>
      <div className="dbx-tspay-onboarding-banner-cta-container"
				 style={{paddingRight: isLanding && 316}}
      >

        <Button
          className="dbx-tspay-onboarding-banner-button"
          onClick={isLanding ? () => startOnboardingSession() : () => goToTsPayLanding() }
          style={{width: isLanding && 169}}
        >
          {isLoadingOnboardingSession ?
            <SimpleLoader />
            :
            <FormattedMessage id={isLanding ? "actions.activate" : "actions.discoverMore"} />
          }
        </Button>
      </div>
    </div>
  );
};

export default TsPayOnboardingBanner;